import React from 'react';
export const Introduction = () => {
  const WebinarLink = ({
    children
  }: {
    children: React.ReactNode;
  }) => <a href="https://stresslessdogs.nl/mcc-gpm" className="text-green-600 hover:text-green-700 hover:underline" data-id="element-61">
      {children}
    </a>;
  return <section className="w-full bg-gray-50 py-12 px-4" data-id="element-62">
      <div className="max-w-4xl mx-auto" data-id="element-63">
        <p className="text-lg md:text-xl mb-6 text-gray-700" data-id="element-64">
          Hondeneigenaren zeggen vaak dat hun trouwe viervoeter hen beter
          begrijpt dan wie ook. Je hond voelt het wanneer je verdrietig bent,
          opgewonden, of troost nodig hebt, zonder dat je een woord hoeft te
          zeggen. Maar hoeveel baasjes begrijpen ook écht wat hun hond voelt?
        </p>
        <p className="text-lg md:text-xl mb-8 text-gray-700" data-id="element-65">
          Als je weleens hebt getwijfeld over wat je hond probeert te zeggen,
          dan is dit artikel wat je zoekt. We duiken in de geest van je hond om
          de geheimen achter hun gedrag te ontdekken, zodat je sterker verbonden
          raakt met je viervoeter dan ooit tevoren.
        </p>
      </div>
    </section>;
};